import { Component, OnInit } from '@angular/core';
import { NavigationEnd, NavigationCancel, Router } from '@angular/router';
import { LangChangeEvent, TranslateService } from '@ngx-translate/core';
import { AnalyticalToolsService } from './services/analytical-tools.service';
import { VersionCheckService } from './services/VersionCheckService';
import { MessagingService } from 'src/backend/services/messaging.service';
import { Constants } from 'src/@smartmanufacturing/common/constants';
import { ConfigService } from './services/config.service';
import { DeploymentDetectorService } from './services/deployment-detector.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
})
export class AppComponent implements OnInit {
  title = 'Obeikan Client';
  isLoading = false;
  showContent = false;
  rcaUrl = [
    '/at',
    '/at/sixwtwoh',
    '/at/fishbone',
    '/at/causeEffect',
    '/at/fivewhy',
    '/at/fivewhy-actpln',
  ];
  public languageDir = 'ltr';
  constructor(
    private router: Router,
    private translate: TranslateService,
    private analyticalToolsService: AnalyticalToolsService,
    private versionCheck: VersionCheckService,
    private messagingService: MessagingService,
    private configService: ConfigService,
    private deploymentDetector: DeploymentDetectorService
  ) {
    // Initialize Constants with ConfigService for runtime configuration
    Constants.initializeConfig(this.configService);
    console.log('✅ Constants initialized with runtime config');
    
    this.translate.onLangChange.subscribe((event: LangChangeEvent) => {
      if (event.lang === 'ar') {
        this.languageDir = 'ltr';
      }
      else {
        this.languageDir = 'ltr';
      }
    });

    // firebase notification initialization
    this.messagingService.receiveMessage();
    // signal R initialization
    this.messagingService.InitializeSignalR();
    this.messagingService.recieveNotificationMessageFromSignalR();
  }

  ngOnInit(): void {
    //clear cache 
    this.versionCheck.initVersionCheck(Constants.API_VERSION);
    this.router.events.subscribe((event) => {
      const url = document.location.href;
      const checkurl = document.location.origin + '/NewSfdc';
      if (url === checkurl) {
        document.body.className = 'body_hide';
        document.body.style.paddingBottom = '0px';
      } else {
        document.body.className = 'body_change';
        document.body.style.paddingBottom = '90px';
      }
      if (event instanceof NavigationEnd || event instanceof NavigationCancel) {
        this.showContent = true;
        if (event.url !== '/' && !this.rcaUrl.includes(event.url)) {
          this.analyticalToolsService.setRca(false);
          this.analyticalToolsService.setRcaId(0);
          this.analyticalToolsService.setHeaderId(0);
          this.analyticalToolsService.setFilteredIndex(0);
          this.analyticalToolsService.setFilteredData([]);
          this.analyticalToolsService.setTeamLeaderList([]);
        }
      }

    });
     this.deploymentDetector.initializeUpdateCheck();
  }

  
}
